<template>
  <DetailWithIcon>
    <template #icon>
      <i class="icon-globe" />
    </template>
    <template #detail-text>
      {{ i18n.t('public.events.virtual') }}
    </template>
  </DetailWithIcon>
</template>

<script>
import DetailWithIcon from './detail-with-icon'
export default {
  components: {
    DetailWithIcon
  }
}
</script>

